import { Checkbox, Table, TableBody, TableHead } from "@material-ui/core";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import OpenInNewOutlinedIcon from "@mui/icons-material/OpenInNewOutlined";
import IndeterminateCheckBoxOutlinedIcon from "@mui/icons-material/IndeterminateCheckBoxOutlined";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import moment from "moment";
import React, { memo } from "react";
import styled from "styled-components";
// import Table from "@material-ui/core/Table";
// import TableBody from "@material-ui/core/TableBody";
import { MyCheckbox } from "components";
import { formatDate, numberFormat } from "helper";
import thousands from "thousands";
import { DateFormetContext } from "../../../../app/App.js";
import { CheckFloatValue } from "../../../../utils/functions.js";
import { fontConfig } from "theme/fontConfig";
const ExpandableRow = (props) => {
  const {
    row,
    onCheckboxChange,
    setDrawerData,
    setOpenModal,
    filters,
    type,
    ChargesCheck,
    PaymentsCheck,
  } = props;
  const dateFormet = React.useContext(DateFormetContext);
  const [open, setOpen] = React.useState(false);
  const getCommaSeperatedValue = (num) => {
    if (
      row?.charge?.payment?.convenient_fee_by?.convenient_fee_by === "member"
    ) {
      let sumValue = num + row?.charge?.payment?.convenient_fee ?? 0;
      let newSumValue = CheckFloatValue(
        parseFloat(sumValue?.toString().replace(/,/g, ""))
      ).toLocaleString();
      return newSumValue;
    }
    return CheckFloatValue(num)
      ?.toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  return (
    <React.Fragment>
      <TableRow
        sx={{ "& > *": { borderBottom: "unset" } }}
        className={`${open && "MuiTableRow-root-temp2"}`}
      >
        <TableCell padding="checkbox" className="main-check">
          {type === "charge" ? (
            <MyCheckbox
              color="default"
              handlechange={(e) => onCheckboxChange(e, row)}
              checked={ChargesCheck?.includes(row?.charge?._id)}
            />
          ) : (
            <MyCheckbox
              color="default"
              handlechange={(e) => onCheckboxChange(e, row)}
              checked={PaymentsCheck?.includes(row?.charge?.payment?.History?._id)}
            />
          )}
        </TableCell>

        <TableCell
          align="left"
          onClick={() => {
            // setDrawerData(row);
            // setOpenModal(true);
          }}
        >
          {filters?.status === "charge" ? (
            <div className="">
              <div
                className="status"
                style={
                  (row?.charge?.status).toUpperCase() === "CHARGE".toUpperCase()
                    ? { color: "#FBA12C" }
                    : (row?.charge?.status).toUpperCase() ===
                      "PAYMENT".toUpperCase()
                      ? { color: "#81DC91" }
                      : {}
                }
              >
                {row?.charge?.status.toUpperCase()}
              </div>
              <div className="transaction-payment-status table-row">
                {row?.charge?.payment.status}
              </div>
              <div className="sub-status">
                {row?.charge?.payment.status ?? row?.charge?.sub_status}
              </div>
            </div>
          ) : row.charge?.payment?.History?.length >= 1 ? (
            <div style={{ display: "flex", alignItems: "flex-start" }}>
              <IconButton
                aria-label="expand row"
                size="large"
                onClick={() => setOpen(!open)}
              >
                {open ? (
                  <IndeterminateCheckBoxOutlinedIcon
                    style={{ height: "29px", width: "29px" }}
                  />
                ) : (
                  <AddBoxOutlinedIcon
                    style={{ height: "29px", width: "29px" }}
                  />
                )}
              </IconButton>

              <span
                className="transaction-led-sub table-row pl-2 sub"
                style={
                  (row?.charge?.status).toUpperCase() === "CHARGE".toUpperCase()
                    ? {
                      color: "#FBA12C",
                      alignSelf: "center",
                      fontFamily: fontConfig.FinanceSubFont.family,
                      fontStyle: "normal",
                      fontWeight: "500",
                      fontSize: "10px",
                      lineHeight: "15px",
                    }
                    : (row?.charge?.status).toUpperCase() ===
                      "PAYMENT".toUpperCase()
                      ? {
                        color: "#81DC91",
                        alignSelf: "center",
                        fontFamily: fontConfig.FinanceSubFont.family,
                        fontStyle: "normal",
                        fontWeight: "500",
                        fontSize: "10px",
                        lineHeight: "15px",
                      }
                      : {}
                }
              >
                {row?.charge?.status.toUpperCase()}
              </span>
            </div>
          ) : (
            <TableCell/>
          )}
        </TableCell>
        <TableCell
          align="left"
          onClick={() => {
            setDrawerData(row);
            setOpenModal(true);
          }}
        >
          <div className="transaction-led-sub table-row">
            <p className="sub">
              {formatDate({date:(row?.charge?.payment?.History?.created_at ?? row?.createdAt ?? row?.created_at), formatType: "defaultWithUTC"})}
            </p>
          </div>
        </TableCell>
        <TableCell
          align="left"
          onClick={() => {
            setDrawerData(row);
            setOpenModal(true);
          }}
        >
          <div className="transaction-led-sub table-row">
            <p className="sub">
              {formatDate({date:row?.charge?.due_date, formatType: "defaultWithUTC"})}
            </p>
          </div>
        </TableCell>
        <TableCell
          align="left"
          onClick={() => {
            setDrawerData(row);
            setOpenModal(true);
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
            <div className="transaction-account-name ellipsDueAmount">{row?.Account?.name}</div>
            {(row?.Account?.id ?? row?.Account?._id) && (
              <a
                href={`/member-details/${row?.Account?.id ?? row?.Account?._id}`}
                target="_blank"
                rel="noreferrer"
                onClick={(e) => e.stopPropagation()}
                style={{ display: "flex", alignItems: "center", color: "#2555EF", flexShrink: 0 }}
              >
                <OpenInNewOutlinedIcon style={{ fontSize: 10, width: 18, height: 18 }} />
              </a>
            )}
          </div>
        </TableCell>
        {/* <TableCell
          align="left"
          onClick={() => {
            setDrawerData(row);
            setOpenModal(true);
          }}
        >
          <div className="transaction-account-name ">{row?.charge_type}</div>
        </TableCell> */}
        <TableCell
          align="left"
          onClick={() => {
            setDrawerData(row);
            setOpenModal(true);
          }}
        >
          <div className="transaction-charged table-row">
            {numberFormat({number:(row?.charge?.payment?.History?.amount ?? row?.charge?.amount + row?.charge?.discount), decimal:2, style: 'currency'})}
          </div>
        </TableCell>
        {type === "payment" && (
        <TableCell
          align="left"
          onClick={() => {
            setDrawerData(row);
            setOpenModal(true);
          }}
        >
          <div className="transaction-charged table-row">
            {row?.bulkAmount ? numberFormat({number:(row?.bulkAmount), decimal:2, style: 'currency'}) : "-"}
          </div>
        </TableCell>
        )}
        {type === "payment" && (
          <TableCell
            align="left"
            onClick={() => {
              setDrawerData(row);
              setOpenModal(true);
            }}
          >
            <div className="transaction-led-sub table-row">
              <p className="sub">
                {row?.charge?.payment?.History?.paymnetMethod?.method?.replaceAll("_", " ")}
              </p>
            </div>
          </TableCell>
        )}
        <TableCell
          align="left"
          onClick={() => {
            setDrawerData(row);
            setOpenModal(true);
          }}
        >
          <div className="transaction-led-sub table-row">
            <div className="sub">{row?.Ledger?.name}</div>
            <div className="led">{row?.SubLedger?.name ?? "N/A"}</div>
          </div>{" "}
        </TableCell>
        <TableCell
          align="left"
          onClick={() => {
            setDrawerData(row);
            setOpenModal(true);
          }}
        >
          <div className="transaction-trans table-row">
            {row?.charge?.payment?.History?._id
              ? row?.charge?.payment?.History?._id
              : row._id
                ? row._id
                : "-"}
          </div>{" "}
        </TableCell>
      </TableRow>
      {open &&
        row.charge?.payment.History.map((item) => (
          <TableRow className="MuiTableRow-root-temp">
            <TableCell align="left"></TableCell>
            <TableCell align="left" style={{ paddingLeft: "48px" }}>
              <div
                className="status transaction-status"
                style={
                  row?.charge?.status === "charged"
                    ? { color: "#FBA12C" }
                    : row?.charge?.status === "payment"
                      ? { color: "#81DC91" }
                      : {}
                }
              >
                {row?.charge?.status.toUpperCase()}
              </div>
              <div className="transaction-payment-status table-row">
                {row?.charge?.payment.status}
              </div>
              <div className="sub-status">
                {row?.charge?.payment.status ?? row?.charge?.sub_status}
              </div>
            </TableCell>

            <TableCell align="left">
              {moment(item.created_at).utcOffset("+0100").format(dateFormet)}
            </TableCell>

            <TableCell align="left">
              <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                <div className="transaction-account-name ellipsDueAmount">{row?.Account?.name}</div>
                {(row?.Account?.id ?? row?.Account?._id) && (
                  <a
                    href={`/member-details/${row?.Account?.id ?? row?.Account?._id}`}
                    target="_blank"
                    rel="noreferrer"
                    onClick={(e) => e.stopPropagation()}
                    style={{ display: "flex", alignItems: "center", color: "#2555EF", flexShrink: 0 }}
                  >
                    <OpenInNewOutlinedIcon style={{ fontSize: 10, width: 18, height: 18 }} />
                  </a>
                )}
              </div>
            </TableCell>

            <TableCell align="left">
              {""}
              {/* <div className="transaction-paid table-row"> */}
              {item?.amount === 0
                ? "0.00"
                : `$${thousands((+item?.amount).toFixed(2))}`}
              {/* {item?.amount ? item?.amount : "0.00"} */}
              {/* </div>{" "} */}
            </TableCell>

            <TableCell align="left">
              <div className="transaction-led-sub table-row">
                <div className="sub">
                  {row?.Ledger?.name ? row?.Ledger?.name : "-"}
                </div>
                <div className="led">
                  {row?.SubLedger?.name ? row?.SubLedger?.name : "-"}
                </div>
              </div>{" "}
            </TableCell>

            <TableCell align="left">
              {/* <div className="transaction-trans table-row"> */}
              {item._id}
              {/* </div>{" "} */}
            </TableCell>
          </TableRow>
        ))}
    </React.Fragment>
  );
};

export default memo(ExpandableRow);